// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 28px;
}
.dashboard-heading h1 {
  margin: 10px 0;
}
.dashboard-heading p {
  color: var(--lkfr-muted);
  font-size: 14px;
  margin: 0;
}

.dashboard-heading-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.dashboard-heading-actions svg {
  width: 18px;
  height: 18px;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  gap: 20px;
  margin: 22px 0 30px;
}

.dashboard-panel {
  background: white;
  border: 1px solid var(--lkfr-border);
  border-radius: 18px;
  padding: 24px;
  min-width: 0;
}

.dashboard-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}
.dashboard-section-head h2 {
  margin: 7px 0 0;
  font-size: 19px;
  font-weight: 600;
}
.dashboard-section-head > a {
  color: var(--lkfr-muted);
  text-decoration: none;
  font-size: 12px;
  white-space: nowrap;
}

.dashboard-situations {
  display: grid;
}

.dashboard-situation {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 15px 0;
  color: var(--lkfr-ink);
  text-decoration: none;
  border-bottom: 1px solid var(--lkfr-border);
}
.dashboard-situation:last-child {
  border: 0;
}
.dashboard-situation > span:nth-child(2) {
  flex: 1 1;
  min-width: 0;
}
.dashboard-situation strong {
  display: block;
  font-size: 14px;
  font-weight: 500;
}
.dashboard-situation small {
  display: block;
  color: var(--lkfr-muted);
  font-size: 12px;
  margin-top: 5px;
  overflow-wrap: anywhere;
}
.dashboard-situation > span:last-child {
  color: var(--lkfr-muted);
}

.dashboard-situation-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  background: #f1f4f7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.dashboard-situation-icon svg {
  width: 20px;
  height: 20px;
}
.dashboard-situation-icon.shift {
  color: #a56c15;
  background: #fff7e7;
}
.dashboard-situation-icon.support {
  color: #bf1e32;
  background: #fff0f2;
}

.dashboard-freshness {
  font-size: 11px;
  color: var(--lkfr-muted);
  margin-top: 16px;
}

.dashboard-empty {
  min-height: 155px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
  padding: 10px 0;
}
.dashboard-empty strong {
  font-size: 15px;
  font-weight: 500;
}
.dashboard-empty p {
  margin: 0;
  color: var(--lkfr-muted);
  font-size: 13px;
  max-width: 390px;
}

.dashboard-empty-icon {
  width: 36px;
  height: 36px;
  border-radius: 11px;
  background: #f0f6f3;
  display: grid;
  place-items: center;
  color: #21764e;
}
.dashboard-empty-icon svg {
  width: 21px;
  height: 21px;
}

.dashboard-empty-icon.uncertain {
  background: #f1f4f7;
  color: var(--lkfr-muted);
}

.dashboard-attention-notice {
  margin: 12px 0 0;
  font-size: 12px;
  color: var(--lkfr-muted);
}

.dashboard-skeleton {
  display: grid;
  gap: 16px;
  padding: 16px 0;
}
.dashboard-skeleton span {
  height: 38px;
  background: linear-gradient(90deg, #f2f4f7, #fafbfc, #f2f4f7);
  border-radius: 9px;
}

.lkfr-app .dashboard-revenue .revenue-card, .lkfr-app .dashboard-records .records-preview-list {
  box-shadow: none;
  border-radius: 0;
  margin-bottom: 0;
}

.lkfr-app .dashboard-revenue .revenue-card {
  min-height: 190px;
  padding: 12px 0 0;
}

.lkfr-app .dashboard-panel .section-title {
  font-size: 19px;
  font-weight: 600;
  margin: 0 0 20px;
}

.lkfr-app .dashboard-revenue .progress-fill.plan {
  background: #cbd2df;
}

.lkfr-app .dashboard-revenue .progress-fill.fact {
  background: var(--lkfr-accent);
}

.lkfr-app .dashboard-revenue .progress-fill.forecast {
  background: #e6b058;
}

.lkfr-app .dashboard-revenue .circle-chart circle.fact {
  stroke: var(--lkfr-accent);
}

.dashboard-panel-link {
  display: block;
  text-decoration: none;
  color: var(--lkfr-muted);
  font-size: 12px;
  margin-top: 15px;
}

.dashboard-help {
  display: flex;
  gap: 18px;
  align-items: flex-start;
}
.dashboard-help h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 10px 0;
}
.dashboard-help p {
  font-size: 14px;
  color: var(--lkfr-muted);
}

.dashboard-help-icon {
  width: 44px;
  height: 44px;
  border-radius: 13px;
  display: grid;
  place-items: center;
  color: var(--lkfr-accent);
  background: var(--lkfr-accent-soft);
  flex-shrink: 0;
}

.dashboard-services {
  margin-bottom: 30px;
}

.dashboard-service-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.dashboard-service {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 14px;
  min-width: 0;
  padding: 18px;
  border: 1px solid var(--lkfr-border);
  border-radius: 14px;
  text-decoration: none;
  color: var(--lkfr-ink);
  background: white;
  transition: border-color 0.15s;
}
.dashboard-service > span:nth-child(2) {
  width: 100%;
  order: 3;
}
.dashboard-service > span:last-child {
  margin-left: auto;
  color: #a4adbb;
  font-size: 13px;
}
.dashboard-service strong {
  display: block;
  font-size: 14px;
  font-weight: 500;
}
.dashboard-service small {
  display: block;
  color: var(--lkfr-muted);
  font-size: 12px;
  line-height: 1.5;
  margin-top: 5px;
}
.dashboard-service:hover {
  border-color: rgba(231, 47, 68, 0.5019607843);
}

.dashboard-service-icon {
  width: 32px;
  height: 32px;
  color: #5c677b;
}
.dashboard-service-icon svg {
  width: 25px;
  height: 25px;
}

.dashboard-schedule {
  margin-bottom: 24px;
}
.dashboard-schedule .timetable-block {
  margin-top: 22px;
}

.dashboard-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 11px;
  color: var(--lkfr-muted);
  margin-top: 30px;
}
.dashboard-footer a {
  color: inherit;
  text-decoration: none;
}

@media (max-width: 1300px) {
  .dashboard-service-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 800px) {
  .dashboard-heading {
    align-items: flex-start;
    flex-direction: column;
  }
  .dashboard-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .dashboard-service-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 650px) {
  .dashboard-heading {
    gap: 18px;
  }
  .dashboard-heading-actions {
    width: 100%;
  }
  .dashboard-heading-actions a {
    flex: 1 1;
    padding: 10px;
    font-size: 12px;
  }
  .dashboard-panel {
    padding: 18px;
  }
  .dashboard-section-head {
    gap: 10px;
  }
  .dashboard-section-head > a {
    font-size: 11px;
  }
  .dashboard-service {
    padding: 16px;
  }
  .dashboard-service strong {
    font-size: 13px;
  }
  .dashboard-services > .dashboard-section-head {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
  .dashboard-footer {
    align-items: flex-start;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA;EAAqB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,mBAAA;AAMpG;AANyH;EAAK,cAAA;AAS9H;AATgJ;EAAI,wBAAA;EAA0B,eAAA;EAAiB,SAAA;AAc/L;;AAbA;EAA6B,aAAA;EAAe,eAAA;EAAiB,SAAA;AAmB7D;AAnBwE;EAAM,WAAA;EAAa,YAAA;AAuB3F;;AAtBA;EAAkB,aAAA;EAAe,uDAAA;EAAyD,SAAA;EAAW,mBAAA;AA6BrG;;AA5BA;EAAmB,iBAAA;EAAmB,oCAAA;EAAsC,mBAAA;EAAqB,aAAA;EAAe,YAAA;AAoChH;;AAnCA;EAA0B,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,mBAAA;AA2CzG;AA3C8H;EAAK,eAAA;EAAiB,eAAA;EAAiB,gBAAA;AAgDrK;AAhDyL;EAAM,wBAAA;EAA0B,qBAAA;EAAuB,eAAA;EAAiB,mBAAA;AAsDjQ;;AArDA;EAAwB,aAAA;AAyDxB;;AAxDA;EAAuB,aAAA;EAAe,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,sBAAA;EAAwB,qBAAA;EAAuB,2CAAA;AAkEtI;AAlEmL;EAAe,SAAA;AAqElM;AArE+M;EAAsB,SAAA;EAAS,YAAA;AAyE9O;AAzE8P;EAAS,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AA8ExS;AA9E4T;EAAQ,cAAA;EAAgB,wBAAA;EAA0B,eAAA;EAAiB,eAAA;EAAiB,uBAAA;AAqFhZ;AArF2a;EAAoB,wBAAA;AAwF/b;;AAvFA;EAA4B,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;AAkG9J;AAlG8K;EAAM,WAAA;EAAa,YAAA;AAsGjM;AAtGiN;EAAU,cAAA;EAAgB,mBAAA;AA0G3O;AA1GkQ;EAAY,cAAA;EAAgB,mBAAA;AA8G9R;;AA7GA;EAAuB,eAAA;EAAiB,wBAAA;EAA0B,gBAAA;AAmHlE;;AAlHA;EAAmB,iBAAA;EAAmB,aAAA;EAAe,uBAAA;EAAyB,uBAAA;EAAyB,sBAAA;EAAwB,SAAA;EAAW,eAAA;AA4H1I;AA5H2J;EAAS,eAAA;EAAiB,gBAAA;AAgIrL;AAhIyM;EAAI,SAAA;EAAW,wBAAA;EAA0B,eAAA;EAAiB,gBAAA;AAsInQ;;AArIA;EAAwB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,aAAA;EAAe,mBAAA;EAAqB,cAAA;AA+IjI;AA/IiJ;EAAM,WAAA;EAAa,YAAA;AAmJpK;;AAlJA;EAAkC,mBAAA;EAAqB,wBAAA;AAuJvD;;AAtJA;EAA8B,gBAAA;EAAkB,eAAA;EAAiB,wBAAA;AA4JjE;;AA3JA;EAAsB,aAAA;EAAe,SAAA;EAAW,eAAA;AAiKhD;AAjKiE;EAAO,YAAA;EAAc,6DAAA;EAA+D,kBAAA;AAsKrJ;;AArKA;EAAiG,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;AA2KrI;;AA1KA;EAA6C,iBAAA;EAAmB,iBAAA;AA+KhE;;AA9KA;EAA4C,eAAA;EAAiB,gBAAA;EAAkB,gBAAA;AAoL/E;;AAnLA;EAAmD,mBAAA;AAuLnD;;AAtLA;EAAmD,8BAAA;AA0LnD;;AAzLA;EAAuD,mBAAA;AA6LvD;;AA5LA;EAAyD,0BAAA;AAgMzD;;AA/LA;EAAwB,cAAA;EAAgB,qBAAA;EAAuB,wBAAA;EAA0B,eAAA;EAAiB,gBAAA;AAuM1G;;AAtMA;EAAkB,aAAA;EAAe,SAAA;EAAW,uBAAA;AA4M5C;AA5MqE;EAAK,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AAiN7G;AAjN+H;EAAI,eAAA;EAAiB,wBAAA;AAqNpJ;;AApNA;EAAuB,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,aAAA;EAAe,mBAAA;EAAqB,yBAAA;EAA2B,mCAAA;EAAqC,cAAA;AA+N3K;;AA9NA;EAAsB,mBAAA;AAkOtB;;AAjOA;EAA0B,aAAA;EAAe,gDAAA;EAAkD,SAAA;AAuO3F;;AAtOA;EAAqB,aAAA;EAAe,uBAAA;EAAyB,eAAA;EAAiB,SAAA;EAAW,YAAA;EAAc,aAAA;EAAe,oCAAA;EAAsC,mBAAA;EAAqB,qBAAA;EAAuB,sBAAA;EAAwB,iBAAA;EAAmB,8BAAA;AAqPnP;AArPkR;EAAsB,WAAA;EAAa,QAAA;AAyPrT;AAzPiU;EAAoB,iBAAA;EAAmB,cAAA;EAAgB,eAAA;AA8PxX;AA9P2Y;EAAS,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAmQrb;AAnQyc;EAAQ,cAAA;EAAgB,wBAAA;EAA0B,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AA0Q9hB;AA1QijB;EAAU,6CAAA;AA6Q3jB;;AA5QA;EAA0B,WAAA;EAAa,YAAA;EAAc,cAAA;AAkRrD;AAlRqE;EAAM,WAAA;EAAa,YAAA;AAsRxF;;AArRA;EAAsB,mBAAA;AAyRtB;AAzR2C;EAAmB,gBAAA;AA4R9D;;AA3RA;EAAoB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,eAAA;EAAiB,wBAAA;EAA0B,gBAAA;AAqS9I;AArSgK;EAAI,cAAA;EAAgB,qBAAA;AAySpL;;AAxSA;EAA6B;IAA0B,gDAAA;EA6SrD;AACF;AA7SA;EAA4B;IAAqB,uBAAA;IAAyB,sBAAA;EAkTxE;EAlTkG;IAAkB,qCAAA;EAqTpH;EArT6J;IAA0B,gDAAA;EAwTvL;AACF;AAxTA;EAA4B;IAAqB,SAAA;EA4T/C;EA5T4D;IAA6B,WAAA;EA+TzF;EA/TsG;IAAI,SAAA;IAAS,aAAA;IAAe,eAAA;EAoUlI;EApUuJ;IAAmB,aAAA;EAuU1K;EAvU2L;IAA0B,SAAA;EA0UrN;EA1UgO;IAAM,eAAA;EA6UtO;EA7U2P;IAAqB,aAAA;EAgVhR;EAhV+R;IAAS,eAAA;EAmVxS;EAnV6T;IAAgD,uBAAA;IAAyB,sBAAA;IAAwB,QAAA;EAwV9Z;EAxV0a;IAAoB,uBAAA;IAAyB,sBAAA;EA4Vvd;AACF","sourcesContent":[".dashboard-heading { display: flex; align-items: center; justify-content: space-between; gap: 24px; margin-bottom: 28px; h1 { margin: 10px 0; } p { color: var(--lkfr-muted); font-size: 14px; margin: 0; } }\n.dashboard-heading-actions { display: flex; flex-wrap: wrap; gap: 10px; svg { width: 18px; height: 18px; } }\n.dashboard-grid { display: grid; grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr); gap: 20px; margin: 22px 0 30px; }\n.dashboard-panel { background: white; border: 1px solid var(--lkfr-border); border-radius: 18px; padding: 24px; min-width: 0; }\n.dashboard-section-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 20px; h2 { margin: 7px 0 0; font-size: 19px; font-weight: 600; } > a { color: var(--lkfr-muted); text-decoration: none; font-size: 12px; white-space: nowrap; } }\n.dashboard-situations { display: grid; }\n.dashboard-situation { display: flex; align-items: center; gap: 14px; padding: 15px 0; color: var(--lkfr-ink); text-decoration: none; border-bottom: 1px solid var(--lkfr-border); &:last-child { border: 0; } > span:nth-child(2) { flex: 1; min-width: 0; } strong { display: block; font-size: 14px; font-weight: 500; } small { display: block; color: var(--lkfr-muted); font-size: 12px; margin-top: 5px; overflow-wrap: anywhere; } > span:last-child { color: var(--lkfr-muted); } }\n.dashboard-situation-icon { width: 38px; height: 38px; border-radius: 12px; background: #f1f4f7; display: flex; align-items: center; justify-content: center; flex-shrink: 0; svg { width: 20px; height: 20px; } &.shift { color: #a56c15; background: #fff7e7; } &.support { color: #bf1e32; background: #fff0f2; } }\n.dashboard-freshness { font-size: 11px; color: var(--lkfr-muted); margin-top: 16px; }\n.dashboard-empty { min-height: 155px; display: flex; align-items: flex-start; justify-content: center; flex-direction: column; gap: 12px; padding: 10px 0; strong { font-size: 15px; font-weight: 500; } p { margin: 0; color: var(--lkfr-muted); font-size: 13px; max-width: 390px; } }\n.dashboard-empty-icon { width: 36px; height: 36px; border-radius: 11px; background: #f0f6f3; display: grid; place-items: center; color: #21764e; svg { width: 21px; height: 21px; } }\n.dashboard-empty-icon.uncertain { background: #f1f4f7; color: var(--lkfr-muted); }\n.dashboard-attention-notice { margin: 12px 0 0; font-size: 12px; color: var(--lkfr-muted); }\n.dashboard-skeleton { display: grid; gap: 16px; padding: 16px 0; span { height: 38px; background: linear-gradient(90deg, #f2f4f7, #fafbfc, #f2f4f7); border-radius: 9px; } }\n.lkfr-app .dashboard-revenue .revenue-card, .lkfr-app .dashboard-records .records-preview-list { box-shadow: none; border-radius: 0; margin-bottom: 0; }\n.lkfr-app .dashboard-revenue .revenue-card { min-height: 190px; padding: 12px 0 0; }\n.lkfr-app .dashboard-panel .section-title { font-size: 19px; font-weight: 600; margin: 0 0 20px; }\n.lkfr-app .dashboard-revenue .progress-fill.plan { background: #cbd2df; }\n.lkfr-app .dashboard-revenue .progress-fill.fact { background: var(--lkfr-accent); }\n.lkfr-app .dashboard-revenue .progress-fill.forecast { background: #e6b058; }\n.lkfr-app .dashboard-revenue .circle-chart circle.fact { stroke: var(--lkfr-accent); }\n.dashboard-panel-link { display: block; text-decoration: none; color: var(--lkfr-muted); font-size: 12px; margin-top: 15px; }\n.dashboard-help { display: flex; gap: 18px; align-items: flex-start; h2 { font-size: 20px; font-weight: 600; margin: 10px 0; } p { font-size: 14px; color: var(--lkfr-muted); } }\n.dashboard-help-icon { width: 44px; height: 44px; border-radius: 13px; display: grid; place-items: center; color: var(--lkfr-accent); background: var(--lkfr-accent-soft); flex-shrink: 0; }\n.dashboard-services { margin-bottom: 30px; }\n.dashboard-service-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 12px; }\n.dashboard-service { display: flex; align-items: flex-start; flex-wrap: wrap; gap: 14px; min-width: 0; padding: 18px; border: 1px solid var(--lkfr-border); border-radius: 14px; text-decoration: none; color: var(--lkfr-ink); background: white; transition: border-color .15s; > span:nth-child(2) { width: 100%; order: 3; } > span:last-child { margin-left: auto; color: #a4adbb; font-size: 13px; } strong { display: block; font-size: 14px; font-weight: 500; } small { display: block; color: var(--lkfr-muted); font-size: 12px; line-height: 1.5; margin-top: 5px; } &:hover { border-color: #e72f4480; } }\n.dashboard-service-icon { width: 32px; height: 32px; color: #5c677b; svg { width: 25px; height: 25px; } }\n.dashboard-schedule { margin-bottom: 24px; .timetable-block { margin-top: 22px; } }\n.dashboard-footer { display: flex; align-items: center; justify-content: space-between; gap: 12px; font-size: 11px; color: var(--lkfr-muted); margin-top: 30px; a { color: inherit; text-decoration: none; } }\n@media (max-width: 1300px) { .dashboard-service-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }\n@media (max-width: 800px) { .dashboard-heading { align-items: flex-start; flex-direction: column; } .dashboard-grid { grid-template-columns: minmax(0, 1fr); } .dashboard-service-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); } }\n@media (max-width: 650px) { .dashboard-heading { gap: 18px; } .dashboard-heading-actions { width: 100%; a { flex: 1; padding: 10px; font-size: 12px; } } .dashboard-panel { padding: 18px; } .dashboard-section-head { gap: 10px; > a { font-size: 11px; } } .dashboard-service { padding: 16px; strong { font-size: 13px; } } .dashboard-services > .dashboard-section-head { align-items: flex-start; flex-direction: column; gap: 8px; } .dashboard-footer { align-items: flex-start; flex-direction: column; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
